var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductMyshiftCaseStudies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 5.79086 5.79086 4 8 4H16.6667C18.8758 4 20.6667 5.79086 20.6667 8V24C20.6667 26.2091 18.8758 28 16.6667 28H8C5.79086 28 4 26.2091 4 24V8Z",
    fill: "#3448FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 13.6667C6.66667 13.1144 7.11438 12.6667 7.66667 12.6667H13.6667C14.219 12.6667 14.6667 13.1144 14.6667 13.6667C14.6667 14.219 14.219 14.6667 13.6667 14.6667H7.66667C7.11438 14.6667 6.66667 14.219 6.66667 13.6667Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66667 18.3333C6.66667 17.781 7.11438 17.3333 7.66667 17.3333H16.3333C16.8856 17.3333 17.3333 17.781 17.3333 18.3333C17.3333 18.8856 16.8856 19.3333 16.3333 19.3333H7.66667C7.11438 19.3333 6.66667 18.8856 6.66667 18.3333Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 6C23.3333 5.26362 23.9303 4.66667 24.6667 4.66667H26.6667C27.403 4.66667 28 5.26362 28 6V24.2464C28 24.5199 27.9159 24.7869 27.759 25.011L26.3221 27.0637C26.0036 27.5187 25.3298 27.5187 25.0113 27.0637L23.5744 25.011C23.4175 24.7869 23.3333 24.5199 23.3333 24.2464V6Z",
    fill: "#52B9F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMyshiftCaseStudies);
export default __webpack_public_path__ + "static/media/product-myshift-case-studies.26f94ff60cb65a5bd3982d946f323b0f.svg";
export { ForwardRef as ReactComponent };